/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  tableCellClasses,
  Paper,
  Grid,
  Stack,
  styled,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Divider,
  Chip,
  Autocomplete,
  Checkbox,
  DialogActions,
  DialogTitle,
  DialogContent,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import countries from 'i18n-iso-countries';
import { getCountryCallingCode } from 'libphonenumber-js';
import moment from 'moment';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import { Container } from 'reactstrap';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Email, Phone, LocationOn } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PortraitIcon from '@mui/icons-material/Portrait';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import useMediaQuery from '@mui/material/useMediaQuery';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import imagepreview from '../../../media/upload.png';
import NoimageFound from '../../../media/noimage.jpg';
import axios from '../../../utils/axios';
import UIContext from '../../../context/UIContext';
import NoResultsFound from '../../../components/NoResultsFound';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#257180',
  },
  whiteSpace: 'nowrap',
});

const StyledTableCell2 = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#8EB486',
  },
  whiteSpace: 'nowrap',
});

const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const Countrys = {
  INDIA: 'IN',
  'UNITED KINGDOM': 'UK',
  'SRILANKA': 'SL',
};

const idCardTypes = [
  { id: 0, name: 'Select' },
  { id: 1, name: 'Voters ID Card' },
  { id: 2, name: 'Driving License' },
  { id: 3, name: 'PAN Card' },
  { id: 4, name: 'Ration Card' },
  { id: 5, name: 'Aadhar Card' },
  { id: 6, name: 'Passport' },
  { id: 7, name: 'VISA' },
  { id: 8, name: 'Refugee Card' },
];

const statusOptions = [
  { label: 'All', value: '0' },
  { label: 'Hot', value: 'H' },
  { label: 'Cold', value: 'C' },
  { label: 'Warm', value: 'W' },
];

const resetStates = {
  fullName: '',
  dob: '',
  addr1: '',
  addr2: '',
  addr3: '',
  // coo: sessionStorage.getItem('country'),
  coo: '',
  branch: '',
  tel: '',
  alterTel: '',
  mailid: '',
  city: '',
  state: '',
  country: '',
  pincode: '',
  salesPerson: '',
  remarks: '',
  idCardType: '',
  IdCardNo: '',
  IDcardFile: null,
  LeadStatus: '',
  WebAccess: '',
  ExpiryDate: '',
  isActive: true,
  DataType: 'New',
  editid: 0,
  referedby: '',
  referother: '',
};

const LedgerAdd = ({ setDialogOpenState, getAllData, GetCustomerHelpAll, countryList, salesPersons, allCustomerData }) => {
  const theme = useTheme();
  const classes = useStyles();
  const smallScreens = useMediaQuery(theme.breakpoints.down('md'));
  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // handling image file
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB (adjust as needed)
  const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png'];
  const [selectedImageFile, setSelectedImageFile] = useState('');
  const [imagePreview, setImagePreview] = useState('');

  // popup controls
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  // filters data
  const [status, setStatus] = useState('0'); // Filter for status
  const [companyId, setCompanyId] = useState(sessionStorage.getItem('CompanyId'));
  const [searchType, setSearchType] = useState('name');
  const [searchValue, setSearchValue] = useState('');
  const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
  const [dateFilterType, setDateFilterType] = useState('R');
  const [fromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'));

  // load & manage data states
  const [initialValue, setInitialValue] = useState(resetStates);
  const [getDataForView, setGetDataForView] = useState([]);
  const [oneCustomerFollowUps, setOneCustomerFollowUps] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [filtersData, setFiltersData] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [editID, setEditID] = useState('');
  const [transactionBool, setTransactionBool] = useState(false);
  // const [salesPersons, setSalesPersons] = useState([]);

  // pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { totalRows, currentPage } = useMemo(() => {
    const totalRows = getDataForView.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    return { totalRows, currentPage };
  }, [getDataForView, page, rowsPerPage]);

  // State to manage new follow-up details
  const [newFollowUp, setNewFollowUp] = useState({
    customerId: null,
    createdDateTime: null,
    followUpDateTime: '',
    remarks: '',
    action: '',
  });
  const [fieldErrors, setFieldErrors] = useState({ followUpDateTime: false });
  const [isEditing, setIsEditing] = useState(false);
  const [editingRowId, setEditingRowId] = useState(null);
  const [rowDeleteID, setRowDeleteID] = useState(null);
  const [openFollowUpTable, setOpenFollowUpTable] = useState(null);
  const [ledgerDetails, setLedgerDetails] = useState(null);
  const [customerEmailidData, setCustomerEmailidData] = useState([]);
  const [telCode, setTelCode] = useState('  ');
  const [referedby, setReferedby] = useState([]);

    
  const getStateList = async (countryid) => {
    try {
      if (!countryid) return;
      const res = await axios.get(`/signup/GetAllState/${countryid}`);
      setStateList(res.data);
    } catch (err) {
      console.log(err.message);
      setStateList([]);
    }
  };

  const findTelCode = (countryName) => {
    try {
      const countryCode = countries.getAlpha2Code(countryName, 'en');
      setTelCode(`+${getCountryCallingCode(countryCode)}`);
    } catch {
      setTelCode('  ');
    }
  };

  const getIdCardNameById = (id) => {
    // Find the ID card type based on the provided id
    const idCard = idCardTypes.find((card) => card.id === id);

    // If found, return the name, otherwise return an empty string or any fallback value
    return idCard ? idCard.name : '';
  };

  async function GetBranchList(cntry) {
    showLoading();
    try {
      const requestData = {
        CompanyId: 4,
      };

      const config = {
        headers: {
          Country: cntry,
        },
      };
      const response = await axios.post('signup/GetBranchList', requestData, config);
      const {data} = response;
      if (cntry === sessionStorage.getItem('country')) {
        setBranchList(data.filter((i) => i.webBranch !== 'N' && i.BranchName.trim().toLowerCase() !== 'other'));
      } else {
        setBranchList(data.filter((i) => i.webBranch !== 'N'));
        
      }
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

       const GetReferedby = async (cntry) => {
          try {
           const config = {
        headers: {
          Country: cntry,
        },
      };
            const response = await axios.post('signUp/GetReferedby',{},config);
            setReferedby(response.data);
          } catch (err) {
            console.error(err);
          }
        }
  const handleCountryChange = (value) => {
    if (!value) return;
    setStateList([]);
    getStateList(value.CountryId);
    findTelCode(value.CountryName);
  };

  const handleFileChange = (event, fileType) => {
    const file = event.target.files[0];

    // File size validation
    if (file.size > MAX_FILE_SIZE) {
      alert('File size exceeds the maximum allowed size (5 MB).');
      return;
    }

    // File type validation
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      alert('Invalid file type. Allowed types are JPEG, PNG, and PDF.');
      return;
    }

    // Update the selected file and error state based on the fileType
    if (fileType === 'photo') {
      setSelectedImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };


  const fetchAutoCompleteOptions = (value) => {
    if (!value.trim()) {
      setAutoCompleteOptions([]); // Clear options if input is empty
      return;
    }

    const filteredOptions = allCustomerData.filter(
      (item) =>
        searchType === 'name'
          ? item.CustomerName.toLowerCase().includes(value.toLowerCase())
          : item.Phone && item.Phone.includes(value) // Handle empty Phone fields
    );

    const formattedOptions = filteredOptions.map((item) => ({
      label: searchType === 'name' ? item.CustomerName : item.Phone || 'No Phone Available',
      value: item.CustomerId,
      details: searchType === 'name' ? item.CustomerName : item.Phone,
    }));

    setAutoCompleteOptions(formattedOptions);
  };

  const ValidationSchema = useMemo(
    () =>
      Yup.lazy((values) =>
        Yup.object({
          fullName: Yup.string().min(3, 'Customer name is too short').required('Customer name is required'),
          dob: Yup.date()
            .nullable()
            .required('Date of birth is required')
            .test('valid-year', 'Year must be realistic (between 1900 and current year)', function (value) {
              if (!value) return false;
              const year = new Date(value).getFullYear();
              const currentYear = new Date().getFullYear();
              return year >= 1900 && year <= currentYear;
            }),
          addr1: Yup.string().required('Address 1 is required'),
          addr2: Yup.string(),
          addr3: Yup.string(),
          city: Yup.string().required('Enter your city'),
          // state: Yup.object().required('Select state'),
          country: Yup.object().required('Select country'),
          pincode: Yup.string()
            .matches(/^[a-zA-Z0-9 ]+$/, 'Pincode can only contain letters and numbers')
            .max(15, 'Pincode cannot exceed 15 characters')
            .required('Pincode is required'),
          alterTel: Yup.string()
            // .required('Alternative Contact number is required')
            .matches(/^\d+$/, 'Alternative Contact number must contain only digits')
            .min(9, 'Alternative Contact number must be at least 9 digits')
            .max(15, 'Alternative Contact number must not exceed 15 digits'),
          // tel: Yup.string()
          //   .required('Contact number is required')
          //   .matches(/^\d+$/, 'Contact number must contain only digits')
          //   .min(9, 'Contact number must be at least 9 digits')
          //   .max(15, 'Contact number must not exceed 15 digits'),
          tel: Yup.string()
            .required('Contact number is required')
            .matches(/^\d+$/, 'Contact number must contain only digits')
            .min(9, 'Contact number must be at least 9 digits')
            .max(15, 'Contact number must not exceed 15 digits')
            // .test(
            //   'phoneno-exists',
            //   'This phoneno is already registered. Please use another phoneno with existing credentials.',
            //   async (value) => {
            //     if (!value) return false;
            //     try {
            //       const response = await axios.post('Approval/LoginApprovalRoute/VerifyContactNo', { Phone: value });
            //       const data = response.data;
            //       return data.length === 0;
            //     } catch (err) {
            //       console.error(err);
            //       return false;
            //     }
            //   }
            // ),
            .test(
              'phoneno-exists',
              'This phoneno is already registered. Please use another phoneno with existing credentials.',
              async (value) => {
                if (!value) return false;
                try {
                  const response = await axios.post('Approval/LoginApprovalRoute/VerifyContactNo',
                    { Phone: value, CustomerId: values.editid });
                  const {data} = response;
                  return data.length === 0;
                } catch (err) {
                  console.error(err);
                  return false;
                }
              }
            ),
          mailid: Yup.string()
            .email('Invalid email format')
            .max(50, 'Mail ID cannot exceed 50 characters')
            .required('Mail ID is required'),
          coo: Yup.string().required('Country of origin is required'),
          branch: Yup.string().required('Branch is required'),
          remarks: Yup.string().max(100, 'Remarks must not exceed 100 characters'),
          salesPerson: Yup.array().when('coo', {
            is: (coo) => coo === sessionStorage.getItem('Origin'),
            then: (schema) => schema.min(1, 'Assign Sales Person for this customer').required(),
            otherwise: (schema) => schema.notRequired(),
          }),
          idCardType: values.IDcardFile ? Yup.string().required('select idCardType') : Yup.string(),
          IdCardNo: values.IDcardFile
            ? Yup.string()
              .required('IdCardNo is required')
              .matches(/^[a-zA-Z0-9 ]*$/, 'No special characters allowed') // Allows letters, numbers, and spaces
            : Yup.string().matches(/^[a-zA-Z0-9 ]*$/, 'No special characters allowed'),
          LeadStatus: Yup.string().when([], {
            is: () => sessionStorage.getItem('userRole') === 'Sales', // Check if userRole is 'Sales'
            then: (schema) => schema.required('Status is required'), // Make it required
            otherwise: (schema) => schema.notRequired(), // Make it optional
          }),
          // LeadStatus: Yup.string().required('status is required'),
        })
      ),
    [initialValue]
  );

  async function checkInitialCondition(mailid) {
    try {
      const response = await axios.post('login/verifyEmailId', { EmailId: mailid });

      // Assuming the API returns a boolean or a specific value to indicate whether to proceed
      const data = response.data.filter(a => a.WebAccess === 'Y')
      setCustomerEmailidData(data)
      if (data && data.length > 0) {
        // Show the popup message
        // openSnackBar('A transaction is found, cannot proceed!', 'error');
        handleOpenCustomerDialog();
        return true; // Indicate that the process should stop
      }
      return false; // Indicate that the process can continue
    } catch (error) {
      // openSnackBar(error.response?.data || 'Failed to check initial condition!', 'error');
      return true; // Stop the process in case of an error
    }
  }

  const validateFilters = () => {
    const errors = {};
    // Validate fromDate: should not be empty
    if (!fromDate) {
      errors.fromDate = 'From date is required';
    } else if (!moment(fromDate, 'YYYY-MM-DD', true).isValid()) {
      errors.fromDate = 'Invalid date format';
    }

    // Validate toDate: should not be empty and be a valid date
    if (!toDate) {
      errors.toDate = 'To date is required';
    } else if (!moment(toDate, 'YYYY-MM-DD', true).isValid()) {
      errors.toDate = 'Invalid date format';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const [formErrors, setFormErrors] = useState({
    fromDate: '',
    toDate: '',
  });

  const [openConfirmDialogDelete, setOpenConfirmDialogDelete] = useState(false);

  const handleOpenConfirmDialogDelete = () => {
    setOpenConfirmDialogDelete(true);
  };

  const handleCloseConfirmDialogDelete = () => {
    setOpenConfirmDialogDelete(false);
  };

  const [openDialogPreview, setOpenDialogPreview] = useState(false);

  const handleOpenDialogPreview = () => {
    setOpenDialogPreview(true);
  };

  const handleCloseDialogPreview = () => {
    setOpenDialogPreview(false);
  };

  const [openCustomerDialog, setOpenCustomerDialog] = useState(false);

  const handleOpenCustomerDialog = () => {
    setOpenCustomerDialog(true);
  };

  const handleCloseCustomerDialog = () => {
    setOpenCustomerDialog(false);
  };


  useEffect(() => {
    GetBranchList(sessionStorage.getItem('country'));
    GetReferedby(sessionStorage.getItem('country'));
  }, [])

  async function InsertProfile(values) {
    let modifiedUrl;
    const originalUrl = selectedImageFile;
    const baseUrl = `${axios.baseURL}TCMSWeb/`;
    if (typeof originalUrl !== 'object') {
      modifiedUrl = originalUrl.replace(baseUrl, '');
    } else {
      modifiedUrl = selectedImageFile;
    }

    // Mapping the data to the backend API input names
    const formData = new FormData();
    formData.append('CustomerId', values.DataType === 'Edit' ? editID : 0);
    formData.append('CUSTOMERNAME', values.fullName || '');
    formData.append('DOB', moment(values.dob).format('YYYY-MM-DD')); // Assuming backend expects date in YYYY-MM-DD format
    formData.append('Phone', String(values.tel || '').trim());
    formData.append('AlternativePhone', String(values.alterTel || '').trim());
    formData.append('EMAILID', values.mailid || '');
    formData.append('ADDRESS1', values.addr1 || '');
    formData.append('ADDRESS2', values.addr2 || '');
    formData.append('ADDRESS3', values.addr3 || '');
    formData.append('COUNTRY', values.country.CountryName || '');
    formData.append('STATE', values.state ? values.state.StateName : '');
    formData.append('CUSSTATEID', values.state ? values.state.StateId : 0);
    formData.append('CUSCOUNTRYID', values.country.CountryId || '');
    formData.append('ZIPCODE', values.pincode || '');
    formData.append('CITY', values.city || '');
    formData.append('Remarks', values.remarks || '');
    formData.append('IdCardtype', values.idCardType || 0);
    formData.append('IdCardNo', values.IdCardNo || '');
    formData.append('IdCardName', getIdCardNameById(values.idCardType) || '');
    formData.append('SignupRequestDate', moment(values.SignupRequestDate).format('YYYY-MM-DD'));
    formData.append('Origin', values.coo);
    formData.append('ApprovedBy', sessionStorage.getItem('UserId'));
    formData.append('CompanyId', sessionStorage.getItem('CompanyId'));
    formData.append('DocImage', modifiedUrl);
    formData.append('salesExecutives', JSON.stringify(values.salesPerson[0]));
    formData.append('Webaccess', 'Y');
    formData.append('BranchID', values.branch);
    formData.append('Active', values.isActive ? 'Y' : 'N');
    formData.append('DataType', values.DataType);
    formData.append('LeadStatus', values.LeadStatus || '');
    formData.append('Referedby', values.referedby || 0);
    formData.append('OtherReferSource', values.referother || '');

    const config = {
      headers: {
        Country: sessionStorage.getItem('Origin'),
        Origined: values.coo,
        'Content-Type': 'multipart/form-data',
      },
    };
    try {
      showLoading();
      const res = await axios.post('Approval/LoginApprovalRoute/LedgerInsert', formData, config);
      const id = res.data?.action?.recordset[0].CustomerId
      await getAllData();
      await GetCustomerHelpAll();
      setDialogOpenState(false)
      //   if (values.coo === sessionStorage.getItem('Origin')) {
      await SendMailOnLedgerCreated(values.DataType === 'Edit' ? editID : id);
      if (sessionStorage.getItem('userRole') === 'Admin') await SendMailForAsssignedSalesPerson(values.DataType === 'Edit' ? editID : id);
      //   }

      // if (salesData.length > 0 && values.salesPerson[0].salesPersonId !== salesData[0].salesPersonId) {
      //   await SendMailForAsssignedSalesPerson(editID);
      // }
      openSnackBar('Customer Has Been Created Successfully !', 'success');
    } catch (e) {
      // openSnackBar('Something Went Wrong try Again !', 'error');
    }
    setDialogOpenState(false)
    hideLoading();
  }

  async function SendMailOnLedgerCreated(editID) {
    try {
      showLoading();
      const response = await axios.post('notifications/mails/sendMail', {
        MailScenario: 'SendMailOnLedgerCreated',
        customerid: editID,
      });
      if (response.status === 200) {
        openSnackBar('Mail Has Been Sent Successfully!, Please check Your Email', 'success');
      }
    } catch (e) {
      // openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function SendMailForAsssignedSalesPerson(editID) {
    try {
      showLoading();
      const response = await axios.post('notifications/mails/sendMail', {
        MailScenario: 'SendMailForAsssignedSalesPerson',
        customerid: editID,
      });
      if (response.status === 200) {
        openSnackBar('Mail Has Been Sent Successfully!, Please check Your Email', 'success');
      }
    } catch (e) {
      // openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const handleReviewClick = async (dataa, setFieldValue, values) => {
    setEditID(dataa.CustomerId);
    const res = await axios.get(`Approval/LoginApprovalRoute/GetOneCustomer/${dataa.CustomerId}`);
   const data = res.data[0];
   console.log(data,'daraa')

    if (Number(data.CusCountryId) !== 0) getStateList(data.CusCountryId);
    if (sessionStorage.getItem('Origin') === 'IN') {
      if (data.IdCardNo && data.IdCardtype) {
        setImagePreview(`${axios.defaults.inImageURL}/MT${data.IdCardNo}-${getIdCardNameById(data.IdCardtype)}.jpg`);
        setSelectedImageFile(
          `${axios.defaults.inImageURL}/MT${data.IdCardNo}-${getIdCardNameById(data.IdCardtype)}.jpg`
        );
      } else {
        setImagePreview('');
        setSelectedImageFile('');
      }
    } else if (sessionStorage.getItem('Origin') === 'UK') {
      if (data.IdCardNo && data.IdCardtype) {
        setImagePreview(`${axios.defaults.ukImageURL}/MT${data.IdCardNo}-${getIdCardNameById(data.IdCardtype)}.jpg`);
        setSelectedImageFile(
          `${axios.defaults.ukImageURL}/MT${data.IdCardNo}-${getIdCardNameById(data.IdCardtype)}.jpg`
        );
      } else {
        setImagePreview('');
        setSelectedImageFile('');
      }
    }else if (sessionStorage.getItem('Origin') === 'SL') {
      if (data.IdCardNo && data.IdCardtype) {
        setImagePreview(`${axios.defaults.slImageURL}/MT${data.IdCardNo}-${getIdCardNameById(data.IdCardtype)}.jpg`);
        setSelectedImageFile(
          `${axios.defaults.slImageURL}/MT${data.IdCardNo}-${getIdCardNameById(data.IdCardtype)}.jpg`
        );
      } else {
        setImagePreview('');
        setSelectedImageFile('');
      }
    }

    // Fetch state list based on the country ID
    let stateList = [];
    try {
      if (!data.CusCountryId) return;
      const stateResponse = await axios.get(`/signup/GetAllState/${data.CusCountryId}`);
      if (stateResponse) {
        stateList = stateResponse.data;
        setStateList(stateList);
      }
    } catch (err) {
      console.log(err.message);
      setStateList([]);
    }

    // Find the state from the stateList based on the StateId
    const selectedState = stateList.find((state) => state.StateId === data.STATEID) || null;

    GetBranchList(sessionStorage.getItem('country'));
    setTransactionBool(data.TransactionFound === 1 && data.WebAccess !== 'T');
    const countryData = countryList.find((country) => data.CusCountryId === country.CountryId) || ''
    const mappedValues = {
      fullName: data.CustomerName || '',
      dob: moment(data.DOB).format('YYYY-MM-DD'),
      addr1: data.Address1 || '',
      addr2: data.Address2 || '',
      addr3: data.Address3 || '',
      coo: sessionStorage.getItem('country'),
      // branch: branchName === 'other' ? '' : data.BRNACHID || '',
      branch: data.BrnachID || '',
      tel: data.Phone || '',
      alterTel: data.AlternativePhone || '',
      mailid: data.EmailId || '',
      city: data.City || '',
      state: selectedState,
      country: countryData || '',
      pincode: data.ZipCode || '',
      salesPerson: '',
      remarks: data.WebRemarks || '',
      idCardType: data.IdCardtype || '',
      IDcardFile: null,
      IdCardNo: data.IdCardNo || '',
      WebAccess: data.WebAccess || '',
      isActive: data.Active === 'Y'
      // editid: data.CustomerId
    };
    findTelCode(countryData.CountryName);
    // setInitialValue(mappedValues);
    Object.entries(mappedValues).forEach(([key, value]) => {
      setFieldValue(key, value);
    });
  };


  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {transactionBool && (
          <Stack sx={{ p: 1 }}>
            <Chip
              label={
                <Typography sx={{ whiteSpace: "normal", wordBreak: "break-word", fontSize: '12px' }}>
                  A transaction is found, can't change the origin.
                </Typography>
              }
              size="small"
              color="warning"
              variant="contained"
              icon={<ReportGmailerrorredIcon />}
              sx={{ mb: 1, height: "auto" }}
            />
          </Stack>
        )}
        <Grid m={2}>
          <Container component={Paper} elevation={2}>
            <Stack sx={{ p: 2 }}>
              <Paper>
                <Formik
                  validationSchema={ValidationSchema}
                  initialValues={initialValue}
                  onSubmit={async (values, { resetForm }) => {
                    const shouldExit = await checkInitialCondition(values.mailid);
                    if (shouldExit) {
                      return;
                    }
                    await InsertProfile({ ...initialValue, ...values });
                    resetForm();
                  }}
                >
                  {({
                    submitForm,
                    touched,
                    values,
                    errors,
                    handleChange,
                    handleBlur,
                    isSubmitting,
                    setFieldTouched,
                    validateForm,
                    resetForm,
                    setFieldValue,
                  }) => (
                    <Form>
                      <Divider sx={{ my: 2 }} variant="middle">
                        <Chip label="Select Ledger" size="small" color="primary" />
                      </Divider>
                      <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                        <Grid item md={5} xs={12}>
                          {/* Search Type Selector */}
                          <TextField
                            fullWidth
                            select
                            label="Search By"
                            value={searchType}
                            onChange={(e) => {
                              setSearchType(e.target.value);
                              setSearchValue('');
                              setAutoCompleteOptions([]);
                            }}
                            variant="outlined"
                            size="small"
                          >
                            <MenuItem value="name">Customer Name</MenuItem>
                            <MenuItem value="phone">Phone Number</MenuItem>
                          </TextField>
                        </Grid>
                        <Grid item md={5} xs={12}>
                          {/* Autocomplete for Search Input */}
                          <Autocomplete
                            // freeSolo
                            options={autoCompleteOptions.filter((option) =>
                              option.details ? option.details.toLowerCase().startsWith(searchValue?.details?.toLowerCase()) : false
                            )}
                            value={searchValue || null}
                            getOptionLabel={(option) => (typeof option === 'string' ? option : option.details)} // Ensure it displays details
                            onInputChange={(event, value) => {
                              setSearchValue({ details: value });
                              fetchAutoCompleteOptions(value);
                            }}
                            onChange={(event, newValue) => {
                              if (newValue) {
                                setSearchValue(newValue);
                                setFieldValue('DataType', 'Edit')
                                setFieldValue('editid', newValue.value)
                              } else {
                                setSearchValue(null);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={`Search by ${searchType === 'name' ? 'Name' : 'Phone'}`}
                                variant="outlined"
                                size="small"
                              />
                            )}
                          />
                        </Grid>
                        <Grid item md={2} xs={12}>
                          <Stack direction="row" justifyContent="center" gap={2}>
                            <Button
                              onClick={() => {
                                const data = allCustomerData.find(i => Number(i.CustomerId) === Number(searchValue.value))
                                handleReviewClick(data, setFieldValue, values)
                              }}
                              variant="contained"
                              color="warning"
                              size="small"
                              sx={{ boxShadow: 1 }}
                            >
                              Load
                            </Button>
                            <Button
                              onClick={() => {
                                resetForm();
                                setInitialValue(resetStates);
                                setSearchValue('');
                              }}
                              variant="contained"
                              color="error"
                              size="small"
                              sx={{ boxShadow: 1 }}
                            >
                              Reset
                            </Button>
                          </Stack>
                        </Grid>
                      </Grid>
                      <Divider sx={{ my: 2 }} variant="middle">
                        <Chip label="Add Ledger" size="small" color="primary" />
                      </Divider>

                      <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                        <Grid item xs={12}>
                          <Stack justifyContent={'end'} alignItems={'end'}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Switch
                                    size='small'
                                    color='success'
                                    checked={values.isActive}
                                    mt={2}
                                    onChange={(event) =>
                                      setFieldValue("isActive", event.target.checked) // Update Formik state
                                    }
                                  />} label="Active" />
                            </FormGroup>
                          </Stack>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Name"
                            type="text"
                            name="fullName"
                            onBlur={handleBlur}
                            error={touched.fullName && !!errors.fullName}
                            helperText={touched.fullName && errors.fullName ? errors.fullName : ''}
                            value={values.fullName}
                            onChange={(e) => {
                              handleChange(e)
                              setFieldValue('coo', sessionStorage.getItem('country'))
                            }}
                            required
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Date Of Birth"
                            type="date"
                            name="dob"
                            InputLabelProps={{ shrink: true }}
                            onBlur={handleBlur}
                            error={touched.dob && !!errors.dob}
                            helperText={touched.dob && errors.dob ? errors.dob : ''}
                            value={values.dob}
                            onChange={handleChange}
                            inputProps={{ max: '9999-12-31' }}
                            required
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Email"
                            type="email"
                            name="mailid"
                            onBlur={handleBlur}
                            error={touched.mailid && !!errors.mailid}
                            helperText={touched.mailid && errors.mailid ? errors.mailid : ''}
                            value={values.mailid}
                            onChange={handleChange}
                            required
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <TextField
                            multiline
                            rows={3}
                            fullWidth
                            size="small"
                            label="Address 1"
                            name="addr1"
                            onBlur={handleBlur}
                            error={touched.addr1 && !!errors.addr1}
                            helperText={touched.addr1 && errors.addr1 ? errors.addr1 : ''}
                            value={values.addr1}
                            onChange={handleChange}
                            required
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <TextField
                            multiline
                            rows={3}
                            fullWidth
                            size="small"
                            label="Address 2"
                            name="addr2"
                            onBlur={handleBlur}
                            error={touched.addr2 && !!errors.addr2}
                            helperText={touched.addr2 && errors.addr2 ? errors.addr2 : ''}
                            value={values.addr2}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <TextField
                            multiline
                            rows={3}
                            fullWidth
                            size="small"
                            label="Address 3"
                            name="addr3"
                            onBlur={handleBlur}
                            error={touched.addr3 && !!errors.addr3}
                            helperText={touched.addr3 && errors.addr3 ? errors.addr3 : ''}
                            value={values.addr3}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item md={2} xs={12}>
                          <FormControl fullWidth size="small" fullwidth required>
                            <InputLabel id="Country-select-label">Country of Origin</InputLabel>
                            <Select
                              fullWidth
                              labelId="Country-select-label"
                              value={values.coo}
                              disabled={transactionBool || sessionStorage.getItem('userRole') === 'Sales'}
                              size="small"
                              name="coo"
                              label="Country of Origin"
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue('salesPerson', []);
                                // GetCountryList1(e.target.value);
                                setFieldValue('country', '');
                                setFieldValue('state', '');
                                setFieldValue('branch', '');
                                GetBranchList(e.target.value);
                                GetReferedby(e.target.value)
                                // GetSalesExecutives(e.target.value);
                              }}
                              error={touched.coo && !!errors.coo}
                            >
                              {Object.entries(Countrys).map(([fullName, code]) => (
                                <MenuItem key={code} value={code}>
                                  {fullName}
                                </MenuItem>
                              ))}
                            </Select>
                            {touched.coo && errors.coo && (
                              <Grid item xs={12}>
                                <Typography
                                  variant="caption"
                                  color="error"
                                  className="shake-helper-text"
                                  margin="0 0 0 14px"
                                >
                                  {errors.coo}
                                </Typography>
                              </Grid>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item md={2} xs={12}>
                          <Autocomplete
                            options={countryList}
                            getOptionLabel={(country) => country.CountryName}
                            renderOption={(props, country) => (
                              <li {...props} key={country.Countryid}>
                                {country.CountryName}
                              </li>
                            )}
                            isOptionEqualToValue={(country) => country.CountryId === values.country.CountryId}
                            value={values.country || null}
                            name="country"
                            onChange={(event, value) => {
                              handleCountryChange(value);
                              setFieldValue('country', value);
                              setFieldValue('state', null);
                            }}
                            size="small"
                            onBlur={() => {
                              setFieldTouched('country', true);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Residing Country"
                                error={touched.country && !!errors.country}
                                helperText={touched.country && errors.country}
                                required
                              />
                            )}
                          />
                        </Grid>
                        <Grid item md={2} xs={12}>
                          <Autocomplete
                            options={stateList}
                            getOptionLabel={(state) => state.StateName}
                            renderOption={(props, state) => (
                              <li {...props} key={state.Stateid}>
                                {state.StateName}
                              </li>
                            )}
                            isOptionEqualToValue={(option, value) => option.StateId === value.StateId}
                            value={values.state || null}
                            name="state"
                            onChange={(event, value) => {
                              setFieldValue('state', value);
                            }}
                            size="small"
                            onBlur={() => {
                              setFieldTouched('state', true);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Province/State"
                              // error={touched.state && !!errors.state}
                              // helperText={touched.state && errors.state}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item md={2} xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="City"
                            type="text"
                            name="city"
                            onBlur={handleBlur}
                            error={touched.city && !!errors.city}
                            helperText={touched.city && errors.city ? errors.city : ''}
                            value={values.city}
                            onChange={handleChange}
                            required
                          />
                        </Grid>
                        <Grid item md={2} xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Postal Code"
                            type="text"
                            name="pincode"
                            onBlur={handleBlur}
                            error={touched.pincode && !!errors.pincode}
                            helperText={touched.pincode && errors.pincode ? errors.pincode : ''}
                            value={values.pincode}
                            onChange={handleChange}
                            required
                          />
                        </Grid>
                        <Grid item md={2} xs={12}>
                          {/* <TextField
                            fullWidth
                            size="small"
                            label="Contact No"
                            type="text"
                            name="tel"
                            onBlur={handleBlur}
                            error={touched.tel && !!errors.tel}
                            helperText={touched.tel && errors.tel ? errors.tel : ''}
                            value={values.tel}
                            onChange={(e) => {
                              const numericValue = e.target.value.replace(/[^0-9]/g, '');
                              handleChange({ target: { name: 'tel', value: numericValue } }); // Manually trigger Formik's handleChange
                            }}
                            required
                          // onChange={handleChange}
                          /> */}
                          <FormControl fullWidth size="small" required>
                            <InputLabel htmlFor="outlined-adornment-tel">Contact No</InputLabel>
                            <OutlinedInput
                              id="outlined-adornment-tel"
                              type="text"
                              name="tel"
                              value={values.tel}
                              onChange={(e) => {
                                const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                handleChange({ target: { name: 'tel', value: numericValue } }); // Manually trigger Formik's handleChange
                              }}
                              // onChange={handleChange}
                              onBlur={handleBlur}
                              label="Contact No"
                              error={touched.tel && !!errors.tel}
                              required
                              startAdornment={
                                <InputAdornment position="start">
                                  {telCode}
                                </InputAdornment>
                              } // Optional prefix
                            />
                            {touched.tel && errors.tel && (
                              <Typography variant="caption" color="error">
                                {errors.tel}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item md={2} xs={12}>
                          {/* <TextField
                            fullWidth
                            size="small"
                            label="Alternative  No"
                            type="number"
                            name="alterTel"
                            onBlur={handleBlur}
                            error={touched.alterTel && !!errors.alterTel}
                            helperText={touched.alterTel && errors.alterTel ? errors.alterTel : ''}
                            value={values.alterTel}
                            // onChange={handleChange}
                            onChange={(e) => {
                              const numericValue = e.target.value.replace(/[^0-9]/g, '');
                              handleChange({ target: { name: 'alterTel', value: numericValue } }); // Manually trigger Formik's handleChange
                            }}
                          /> */}
                          <FormControl fullWidth size="small" required>
                            <InputLabel htmlFor="outlined-adornment-tel">Alternative  No</InputLabel>
                            <OutlinedInput
                              id="outlined-adornment-tel"
                              type="text"
                              name="alterTel"
                              value={values.alterTel}
                              onChange={(e) => {
                                const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                handleChange({ target: { name: 'alterTel', value: numericValue } }); // Manually trigger Formik's handleChange
                              }}
                              // onChange={handleChange}
                              onBlur={handleBlur}
                              label="Alternative  No"
                              error={touched.alterTel && !!errors.alterTel}
                              required
                              startAdornment={
                                <InputAdornment position="start">
                                  {telCode}
                                </InputAdornment>
                              } // Optional prefix
                            />
                            {touched.alterTel && errors.alterTel && (
                              <Typography variant="caption" color="error">
                                {errors.alterTel}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item md={2} xs={12}>
                          <FormControl fullWidth size="small" required>
                            <InputLabel>Branch</InputLabel>
                            <Select
                              value={values.branch || ''}
                              name="branch"
                              size="small"
                              label="Branch"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={touched.branch && !!errors.branch}
                            >
                              {branchList.length > 0 ? (
                                values.coo === sessionStorage.getItem('Origin') ? (
                                  // Show all branches if the condition is true
                                  branchList.map((branch) => (
                                    <MenuItem key={branch.BranchId} value={branch.BranchId}>
                                      {branch.BranchName}
                                    </MenuItem>
                                  ))
                                ) : (
                                  // Show only the "Other" branch if the condition is false
                                  branchList
                                    .filter((branch) => branch.BranchName.toLowerCase() === 'other') // Case-insensitive comparison
                                    .map((branch) => (
                                      <MenuItem key={branch.BranchId} value={branch.BranchId}>
                                        {branch.BranchName}
                                      </MenuItem>
                                    ))
                                )
                              ) : (
                                // Handle empty branchList
                                <MenuItem disabled>No branches available</MenuItem>
                              )}
                            </Select>
                            {touched.branch && errors.branch && (
                              <Typography
                                variant="caption"
                                color="error"
                                className="shake-helper-text"
                                margin="4px 0 0 14px"
                              >
                                {errors.branch}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item md={2} xs={12}>
                          <FormControl fullWidth size="small">
                            <InputLabel>ID Card Type</InputLabel>
                            <Select
                              value={values.idCardType || ''}
                              name="idCardType"
                              size="small"
                              label="ID Card Type"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={touched.idCardType && !!errors.idCardType}
                            >
                              {idCardTypes.length > 0 ? (
                                idCardTypes.map((idCard) => (
                                  <MenuItem key={idCard.id} value={idCard.id}>
                                    {idCard.name}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem disabled>No ID card types available</MenuItem>
                              )}
                            </Select>
                            {touched.idCardType && errors.idCardType && (
                              <Typography variant="caption" color="error" margin="4px 0 0 14px">
                                {errors.idCardType}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item md={2} xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="ID Card No"
                            type="text"
                            name="IdCardNo"
                            onBlur={handleBlur}
                            error={touched.IdCardNo && !!errors.IdCardNo}
                            helperText={touched.IdCardNo && errors.IdCardNo ? errors.IdCardNo : ''}
                            value={values.IdCardNo}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <Autocomplete
                            id="salesperson-select"
                            options={salesPersons.filter((option) =>
                              !Array.isArray(values.salesPerson) ||
                              !values.salesPerson.some((selected) => selected.salesPersonId === option.salesPersonId)
                            )}
                            getOptionLabel={(option) => option.salesPersonName || ''}
                            disableCloseOnSelect
                            // value={values.salesPerson?.[0] || null}
                            value={
                              sessionStorage.getItem('userRole') === 'Sales'
                                ? salesPersons.find((sp) => Number(sp.salesPersonId) === Number(sessionStorage.getItem('UserId'))) || null
                                : values.salesPerson?.[0] || null
                            }
                            onBlur={handleBlur}
                            onChange={(event, newValue) => {
                              setFieldValue('salesPerson', newValue ? [newValue] : []);
                            }}
                            renderOption={(props, option) => <li {...props}>{option.salesPersonName}</li>}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                label="Sales Persons"
                                error={!!errors.salesPerson && touched.salesPerson}
                                required
                              />
                            )}
                            style={{ width: '100%' }}
                            disabled={values.coo !== sessionStorage.getItem('Origin') || sessionStorage.getItem('userRole') === 'Sales'}
                          />
                          {touched.salesPerson && errors.salesPerson && (
                            <Typography variant="caption" color="error" margin="4px 0 0 14px">
                              {errors.salesPerson}
                            </Typography>
                          )}
                        </Grid>
                        {sessionStorage.getItem('userRole') === 'Sales' &&
                          <Grid item md={4} xs={12} justifyContent="center" >
                            <Stack
                              direction="row"
                              spacing={1}
                              justifyContent="center"
                              alignItems="center"
                              sx={{ width: '100%', pt: 2 }}
                            >
                              <FormControl fullWidth size="small" required>

                                <InputLabel shrink id="statusLabel">
                                  Status
                                </InputLabel>
                                <div className="radio-input">

                                  <label>
                                    <input
                                      type="radio"
                                      id="hot"
                                      name="LeadStatus"
                                      value="H"
                                      checked={values.LeadStatus === 'H'}
                                      onChange={handleChange}
                                    />
                                    <span style={{ marginRight: '4px' }}>Hot </span>🔥
                                  </label>
                                  <label>
                                    <input
                                      type="radio"
                                      id="cold"
                                      name="LeadStatus"
                                      value="C"
                                      checked={values.LeadStatus === 'C'}
                                      onChange={handleChange}
                                    />
                                    <span style={{ marginRight: '4px' }}>Cold</span> ❄️
                                  </label>
                                  <label>
                                    <input
                                      type="radio"
                                      id="warm"
                                      name="LeadStatus"
                                      value="W"
                                      checked={values.LeadStatus === 'W'}
                                      onChange={handleChange}
                                    />
                                    <span style={{ marginRight: '4px' }}>Warm</span>☀️
                                  </label>
                                  <span className="selection" data-value={values.LeadStatus} />
                                </div>

                                {touched.LeadStatus && errors.LeadStatus && (
                                  <Typography
                                    variant="caption"
                                    color="error"
                                    className="shake-helper-text"
                                    margin="4px 0 0 14px"
                                  >
                                    {errors.LeadStatus}
                                  </Typography>
                                )}
                              </FormControl>
                            </Stack>
                          </Grid>
                        }
                        <Grid item md={4} xs={12}>
                          <Stack direction={'column'} spacing={2}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                              border={1}
                              borderRadius={1}
                              borderColor="#e0e0e0"
                              p={1}
                              justifyContent="center"
                            >
                              <Stack direction="row" alignItems="center" justifyContent={'center'} spacing={1}>
                                <Box>
                                  <label htmlFor="fileInput">
                                    <img
                                      src={
                                        selectedImageFile ===
                                          `${sessionStorage.getItem('Origin') === 'IN'
                                            ? axios.defaults.inImageURL
                                           : sessionStorage.getItem('Origin') === 'UK'
                                                ? axios.defaults.ukImageURL
                                                : axios.defaults.slImageURL
                                          }`
                                          ? NoimageFound
                                          : selectedImageFile === null ||
                                            selectedImageFile === '' ||
                                            !selectedImageFile
                                            ? imagepreview
                                            : imagePreview
                                      }
                                      alt="imgfor"
                                      className={classes.chooseFileButton}
                                      style={{
                                        maxWidth: '200px',
                                        minWidth: '200px',
                                        maxHeight: '92px',
                                        minHeight: '92px',
                                        objectFit: 'contain',
                                      }}
                                    />
                                    <input
                                      className={classes.fileInput}
                                      id="fileInput"
                                      type="file"
                                      accept="image/jpeg"
                                      name="IDcardFile"
                                      onChange={(event) => {
                                        handleFileChange(event, 'photo');
                                        handleChange(event);
                                      }}
                                      style={{ display: 'none' }}
                                    />
                                    {(selectedImageFile || !NoimageFound) && (
                                      <Button
                                        onClick={handleOpenDialogPreview}
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        fullWidth
                                        sx={{ boxShadow: 1 }}
                                        mt={2}
                                      >
                                        Preview
                                      </Button>
                                    )}
                                  </label>
                                </Box>
                              </Stack>
                            </Stack>
                          </Stack>
                        </Grid>
                        <Grid item md={sessionStorage.getItem('userRole') === 'Sales' ? 4 : 8} xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Remarks"
                            type="text"
                            multiline
                            rows={4}
                            name="remarks"
                            onBlur={handleBlur}
                            error={touched.remarks && !!errors.remarks}
                            helperText={touched.remarks && errors.remarks ? errors.remarks : ''}
                            value={values.remarks}
                            onChange={handleChange}
                          />
                        </Grid>
                           <Grid item md={3} xs={12}>
                                                    <FormControl fullWidth size="small" >
                                                      <InputLabel>Referred By </InputLabel>
                                                      <Select
                                                        value={values.referedby || ''}
                                                        name="referedby"
                                                        size="small"
                                                        label="Referred By"
                                                        onChange={(e) => {
                                                          handleChange(e);
                                                          setFieldValue('referother', '');
                                                        }}
                                                        onBlur={handleBlur}
                                                        error={touched.referedby && !!errors.referedby}
                                                      >
                                                        {referedby.length > 0 ? (
                                                          referedby.map((refer) => (
                                                            <MenuItem key={refer.ReferralSourceId} value={refer.ReferralSourceId}>
                                                              {refer.ReferralSourceName}
                                                            </MenuItem>
                                                          ))
                                                        ) : (
                                                          <MenuItem disabled>Not available</MenuItem>
                                                        )}
                                                      </Select>
                                                      
                                                    </FormControl>
                                                  </Grid>
                                                   <Grid item md={3} xs={12}>
                                                      <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Other Referral Source"
                                                        type="text"
                                                        name="referother"
                                                        inputProps={{ maxLength: 50 }}
                                                        onBlur={handleBlur}
                                                        disabled={!referedby.some(ref => ref.ReferralSourceId === values.referedby && ref.ReferralSourceName?.toLowerCase().includes('other'))}
                                                        error={touched.referother && !!errors.referother}
                                                        helperText={touched.referother && errors.referother ? errors.referother : ''}
                                                        value={values.referother || ''}
                                                        onChange={handleChange}
                                                      />
                                                    </Grid>
                      </Grid>

                      <Stack direction="row" justifyContent="center" gap={2} sx={{ textAlign: 'center', mt: 3 }}>
                        <Button
                          onClick={() => {
                            setImagePreview('');
                            setInitialValue({ ...resetStates });
                            setStateList([]);
                            setDialogOpenState(false)
                          }}
                          variant="contained"
                          color="warning"
                          size="small"
                          sx={{ boxShadow: 1 }}
                        >
                          Close
                        </Button>
                        <Button
                          // onClick={submitForm}
                          onClick={() => {
                            if (sessionStorage.getItem('userRole') === 'Sales') {
                              setFieldValue(
                                'salesPerson',
                                Array.isArray(values.salesPerson) ? values.salesPerson :
                                  [salesPersons.find((sp) => Number(sp.salesPersonId) === Number(sessionStorage.getItem('UserId')))]
                              ).then(() => submitForm());
                            } else {
                              submitForm();
                            }
                          }}

                          disabled={isSubmitting}
                          variant="contained"
                          color="primary"
                          size="small"
                          sx={{ boxShadow: 1 }}
                        >
                          Save
                        </Button>
                      </Stack>
                      <Dialog open={openDialogPreview} onClose={handleCloseDialogPreview} maxWidth="md">
                        <DialogTitle>Image Preview</DialogTitle>
                        <DialogContent>
                          <img
                            src={
                              selectedImageFile ===
                                `${sessionStorage.getItem('Origin') === 'IN'
                                  ? axios.defaults.inImageURL
                                : sessionStorage.getItem('Origin') === 'UK'
                                                ? axios.defaults.ukImageURL
                                                : axios.defaults.slImageURL
                                }`
                                ? NoimageFound
                                : selectedImageFile === null || selectedImageFile === '' || !selectedImageFile
                                  ? imagepreview
                                  : imagePreview
                            }
                            alt="Preview"
                            style={{
                              maxWidth: '100%',
                              maxHeight: '400px',
                              objectFit: 'contain',
                            }}
                          />
                        </DialogContent>
                        <DialogActions>
                          <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center">
                            <Button
                              onClick={handleOpenConfirmDialogDelete}
                              color="error"
                              variant="outlined"
                              size="small"
                            >
                              Delete
                            </Button>
                            <Button
                              onClick={handleCloseDialogPreview}
                              color="primary"
                              startIcon={<CloseIcon />}
                              variant="contained"
                              size="small"
                            >
                              Close
                            </Button>
                          </Stack>
                        </DialogActions>
                      </Dialog>
                      <Dialog open={openConfirmDialogDelete} onClose={handleCloseConfirmDialogDelete}>
                        <DialogTitle>Confirm Deletion</DialogTitle>
                        <DialogContent>
                          <Typography>Are you sure you want to delete this image?</Typography>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={handleCloseConfirmDialogDelete} color="primary">
                            Cancel
                          </Button>
                          <Button
                            onClick={() => {
                              setSelectedImageFile(null);
                              setOpenDialogPreview(false);
                              setFieldValue('IdCardNo', '');
                              handleCloseDialogPreview();
                              handleCloseConfirmDialogDelete();
                            }}
                            color="error"
                          >
                            Delete
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </Form>
                  )}
                </Formik>
              </Paper>
            </Stack>
          </Container>
        </Grid>

        <Dialog open={openCustomerDialog} onClose={handleCloseCustomerDialog} maxWidth="md">
          <DialogTitle style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <ErrorOutlineIcon color="error" /> This Email Id already exist.
          </DialogTitle>
          <DialogContent>
            {/* Table to display CustomerName, EmailId, and Status */}
            <Table size="small" aria-label="Customer Details">
              <TableHead>
                <TableRow>
                  <TableCell>Customer Name</TableCell>
                  <TableCell>Email ID</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customerEmailidData.map((customer, index) => (
                  <TableRow key={index}>
                    <TableCell>{customer?.CustomerName}</TableCell>
                    <TableCell>{customer?.EmailId}</TableCell>
                    <TableCell>{customer?.Status}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" mt={2}>
              <Button
                onClick={handleCloseCustomerDialog}
                color="warning"
                startIcon={<CloseIcon />}
                variant="outlined"
                size="small"
              >
                Close
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>
      </Container>
    </>
  );
};

export default LedgerAdd;
